var map = {
	"./announcement.png": "a191",
	"./calendar.png": "6be8",
	"./calendar_02.svg": "0121",
	"./clinic_schedule.png": "ce56",
	"./company.svg": "9618",
	"./consultation-services.svg": "2871",
	"./consultation-unpaid.svg": "5504",
	"./drug_interactions.png": "1d1c",
	"./link-expired.svg": "ba7f",
	"./medical_affiliation.png": "8365",
	"./medicine_branded.svg": "1111",
	"./medicine_generic.svg": "7281",
	"./news.svg": "5124",
	"./no_price.png": "0575",
	"./note-pad.svg": "8876",
	"./related_brands.png": "a131",
	"./related_diseases.png": "8ffd",
	"./reply.png": "b4e1",
	"./search.svg": "312a",
	"./search_blank.svg": "af7f",
	"./search_calendar.svg": "ccc4",
	"./search_device.svg": "9f92",
	"./search_diagnostic.svg": "12d3",
	"./search_disease.svg": "de2d",
	"./search_doctor.svg": "4ab0",
	"./search_hospital.svg": "dc7e",
	"./search_medicine.svg": "a702",
	"./shopping-bag.svg": "c6cb",
	"./video_chat_reminders.svg": "d531"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ef3b";